document.addEventListener('DOMContentLoaded', () => {

	window.config = {
		animation: {
			windowProportion: 9 / 10
		}
	};

	// Get all elements with the .animate-container class
	const containers = document.querySelectorAll('.animate-container');
	const proportion = window.config.animation.windowProportion;

	// Function to add 'reveal' class to elements in view
	const animateOnScroll = () => {
		const scrollY = window.scrollY;
		const windowHeight = window.innerHeight;
		const scrollTrigger = scrollY + (windowHeight * proportion);

		containers.forEach(container => {
			// Instantly reveal elements with 'animate-intro' class
			if (container.classList.contains('animate-intro')) {
				container.classList.add('reveal');
				return;
			}

			// Get the element's position from the top of the page
			const rect = container.getBoundingClientRect();
			const offsetTop = rect.top + scrollY;
			const topValue = parseInt(getComputedStyle(container).top) || 0;
			const scrollTop = offsetTop - topValue;

			// Reveal element if it's within the scroll trigger threshold
			if (scrollTop < scrollTrigger) {
				container.classList.add('reveal');
			}
			// If not in view and not marked as 'animate-once', remove the reveal
			else if (!container.classList.contains('animate-once')) {
				container.classList.remove('reveal');
			}
		});
	};
	animateOnScroll();
	window.addEventListener('scroll', animateOnScroll);
	document.addEventListener('tab-changed', animateOnScroll);
});